<template>
    <div class=" q-mb-md" v-if="items.length > 0"
         :class="{'container': $breakpoints.isGreaterThan('sm')}">
        <h2 class="q-my-md" v-html="$T('home_featured')"
            :class="{'q-px-md': !$breakpoints.isGreaterThan('sm')}"></h2>
        <div class="banners" :class="{'q-pb-md has-border': !$breakpoints.isGreaterThan('sm'),
         'shadow-7': $breakpoints.isGreaterThan('sm')}">
            <div v-if="$breakpoints.isGreaterThan('sm')" class="row">

                <div v-if="first" class="col-8 first" @click="$router.push(first.uri)">
                    <v-img :img="first.img" :key="first.img.url" :is-video="isVideo">
                        <div class="image-caption">
                            <h5 class="q-mt-none q-mb-xs banner-title" v-html="first.title"></h5>
                            <p v-if="first.subtitle" class="q-ma-none" v-html="first.subtitle"></p>
                        </div>
                    </v-img>
                </div>

                <div class="row col-4 content-stretch">
                    <div v-for="item in others" class="col-12" @click="$router.push(item.uri)">
                        <v-img :img="item.img" :key="item.img.url" :is-video="isVideo">
                            <div class="image-caption">
                                <h5 class="q-mt-none q-mb-xs banner-title" v-html="item.title">teste</h5>
                                <p v-if="item.subtitle" class="q-ma-none" v-html="item.subtitle"></p>
                            </div>
                        </v-img>
                    </div>
                </div>

            </div>

            <div v-else class="horizontal-lock carousel q-mt-md">
                <v-carousel layout="big" :items="items" :is-video="isVideo"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VBanners',

        props: {
            items: {
                type: Array,
                required: true,
            },
            isVideo: Boolean,
        },

        computed: {
            first() {
                if (this.items && this.items[0] != undefined)
                    return this.items[0]
            },
            others() {
                if (this.items && this.items.length > 1)
                    return this.items.slice(1, 3)
                return []
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Banners.vue